/* Account.js */
/* @author: anghello */

import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import PageTitle from '../../Layout/Components/PageTitle';
import { useAuth } from '../../Context/Auth/AuthContext';
import Strings from '../../translations/Translations';
import AccountModuleV2 from '../../modules/account/AccountModuleV2/AccountModuleV2';
import ModalChangeEmail from '../../modules/account/AccountModuleV2/ModalChangeEmail';
import ModalChangePassword from '../../modules/account/AccountModuleV2/ModalChangePassword';
import UserCredits from '../../modules/UserCredits/UserCredits';

const PUBLIC_VIDEOS_URL = process.env.REACT_APP_PUBLIC_VIDEOS;

export default function Account() {
  const { clearActiveCampaign, authenticated } = useAuth();

  useEffect(() => {
    clearActiveCampaign();
  }, [clearActiveCampaign]);

  const [isOpenModalChangeEmail, setIsOpenModalChangeEmail] = useState(false);
  const [isOpenModalChangePassword, setIsOpenModalChangePassword] = useState(false);

  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={Strings('account')}
          subheading={Strings('account_description')}
          icon="pe-7s-user"
          externalButtonLabel={Strings('my_remix_videos')}
          externalButtonLink={`${PUBLIC_VIDEOS_URL}f/#/topic/type=user&value=${authenticated.un}`}
        />

        <Row>
          <Col sm="12">
            <UserCredits />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <AccountModuleV2
              changeEmailCallback={() => setIsOpenModalChangeEmail(true)}
              changePasswordCallback={() => setIsOpenModalChangePassword(true)}
            />
          </Col>
        </Row>

        <ModalChangeEmail isOpen={isOpenModalChangeEmail} setIsOpen={setIsOpenModalChangeEmail} />

        <ModalChangePassword isOpen={isOpenModalChangePassword} setIsOpen={setIsOpenModalChangePassword} />
      </PageAnimation>
    </Fragment>
  );
}
